import axios from "axios";
import { triggerLogoutHandler, triggerRefreshIconHandler } from "../../../utils/logoutHandler";
import { showToast } from "../../../components";
import { getResponseMessage } from "../../../utils/getResponseMessage";
import { logoutUser } from "../auth/authApi";
import { BUILD_VERSION } from "../../../configs/buildVersion";
import { getSafeDeviceInfo } from "../../../utils/deviceUtils";
import { useLoginUser } from "../../../hooks/useLoginUser";
import { useSelector } from "react-redux";
let offlineToastShown = false;
let serverToastShown = false;

// ✅ reset offline flag when internet comes back
window.addEventListener("online", () => {
  offlineToastShown = false;
});
const axiosRequest = async ({
  method,
  url,
  data = {},
  params = {},
  headers = {},
   slowConfig = null,
}) => {
 if (!navigator.onLine) {
    if (!offlineToastShown) {
      offlineToastShown = true;

      showToast(
        "You are offline. Please check your internet connection.",
        "error",
        5000
      );

      setTimeout(() => (offlineToastShown = false), 8000);
    }

    return { success: false, error: "No internet connection" };
  }
  const restrictedKeywords = ["master", "workforce","4000","3000","8080","8181","5000","8050"];
  const normalizedUrl = (url || "").toLowerCase();
  const isRestrictedUrl = restrictedKeywords.some(keyword =>
  normalizedUrl.includes(keyword)
);
const ENV = import.meta.env.VITE_APP_ENV || "local";
  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("userId");
  const deviceType = localStorage.getItem("deviceType");
  // const instance = axios.create({
  //   headers: {
  //     'Content-Type': 'application/json',
  //     ...(token && { Authorization: `Bearer ${token}` }),
  //   },
  //   withCredentials: true,
  // });
  // Default headers

  // let ip = null;
  // try {
  //   const res = await fetch("https://api64.ipify.org?format=json");
  //   if (!res.ok) throw new Error("Network error");

  //   const data = await res.json();
  //   ip = data?.ip || null;
  // } catch (err) {
  //   ip = null; // fallback
  // }

  // Default headers
  const defaultHeaders = {
    "Content-Type": "application/json",
    ...(token && { Authorization: `Bearer ${token}` }),
    ...(!isRestrictedUrl && ENV !== "local" && deviceType && { "X-Device-Type": deviceType }),
    ...(!isRestrictedUrl && ENV !== "local" && userId && { "X-User-Uiid": userId }),
    // ...( ip && { "X-User-IP": ip }), // ✅ Added IP Header
  };

  // Merge headers: custom headers override defaults
  const finalHeaders = {
    ...defaultHeaders,
    ...headers,
  };

  const instance = axios.create({
    headers: finalHeaders,
    withCredentials: true,
  });
  instance.interceptors.response.use(
    (response) => {
    const backendVersion = response?.headers?.["x-app-version"];
      if (backendVersion && String(backendVersion) !== String(BUILD_VERSION)&&String(backendVersion)!=="0.0.0") {
      triggerRefreshIconHandler();
    }
      return response
    },
    (error) => {
      //  if (!error.response) {
      //   if (!serverToastShown) {
      //     serverToastShown = true;
      //     showToast(
      //       "Unable to connect to server. Please try again shortly.",
      //       "error",
      //       50000
      //     );

      //     setTimeout(() => (serverToastShown = false), 8000);
      //   }
      //   return Promise.reject(error);
      // }
      if (error.code === "ECONNABORTED") {
        showToast(
          "Server is taking longer than expected. Please try again.",
          "warning",
          50000
        );
        return Promise.reject(error);
      }

      const errorData = error?.response?.data || {};
      const errorMessageFromApi =
        errorData.error?.toLowerCase?.() ||
        error.message?.toLowerCase?.() ||
        "request failed";
      const fieldMessage = errorData?.field?.toLowerCase?.() || "";
      const logoutErrorMessages = [
        "invalid token",
        "invalid user please login",
        "jwt expired",
        "token not found!",
        // "user session invalid or expired!",,
      ];
      const ipSessionErrors = [
        "ip address not found. please login again.",
        "ip address changed. please login again."
      ];
      // Check if error or field message should trigger logout
      const shouldLogout =
        logoutErrorMessages.includes(errorMessageFromApi) ||
        logoutErrorMessages.includes(fieldMessage);

      const isIpSessionError =
        ipSessionErrors.includes(errorMessageFromApi) ||
        ipSessionErrors.includes(fieldMessage);

      if (shouldLogout || isIpSessionError) {

        if (isIpSessionError) {
          localStorage.setItem("logoutReason", "ip_session");
        }

        const isMultipleSession =
          errorMessageFromApi.includes("user session invalid or expired!");

        if (isMultipleSession) {
          localStorage.setItem("logoutReason", "multiple_session");
        }
        triggerLogoutHandler();
      } else {
        // Use sm code to get the message or fallback to error string
        const sm = errorData.sm;
        const field = errorData.field || ""; // if you want to support field param
        const message = sm
          ? getResponseMessage(sm, field)
          : errorMessageFromApi;
        // showToast(message, 'error', 5000);
      }

      return Promise.reject(error);
    }
  );

  try {
    const response = await instance({
      method,
      url,
      data,
      params,
    });
    // Show toast for success response based on sm
    // if (response?.data?.sm) {
    const msg = getResponseMessage(response.data.sm);
    // showToast(msg, 'success', 3000);
    // }
    return {
      success: true,
      data: response.data,
      msg: msg,
    };
  } catch (error) {
    const msg = getResponseMessage(error?.response?.data?.sm, error?.response?.data?.field );
    return {
      success: false,
      error: error?.response?.data?.error || error.message || "Request failed",
      msg: msg,
      errorCode: error?.response?.status,
      field: error?.response?.data?.field || null,
    };
  }
};

export default axiosRequest;